<div class="title-components">
  <h1>Crear nuevo Rol Processes</h1>
</div>

<div class="divider-butons-VH">
  <div (click)="validationRole()" class="btn btn-icon-text-left">
    <span class="text">Guardar</span><i class="fa-solid fa-check-double"></i>
  </div>

  <div routerLink="/Dashboard/FIN/SeeAllRolesGenFIN" class="btn btn-icon">
    <i class="fa-solid fa-angles-left"></i>
  </div>
</div>

<div class="container-global-components ConVH">
  <form [formGroup]="FormRole">
    <div class="Info-Content content">
      <div class="Content-body">
        <div class="Content-grid-2 Content-grid-custom">
          <div class="Text-icon">Nombre</div>
          <div class="Container-input Input-Text-Form">
            <i class="fa-solid fa-signature"></i
            ><input
              formControlName="NameRole"
              id="inputNameRoleFIN"
              type="text"
              placeholder="Nombre del rol…"
            />
          </div>
        </div>

        <div class="Content-grid-2 Content-grid-custom">
          <div class="Text-icon">Descripción</div>
          <div class="Container-input Input-Text-Form">
            <i class="fa-regular fa-comment"></i
            ><input
              formControlName="Description"
              id="inputDescription"
              type="text"
              placeholder="Descripción…"
            />
          </div>
        </div>
      </div>
    </div>
  </form>

  <div class="container-table-tree">
    <p-treeTable
      [value]="Directories"
      [columns]="HeaderGroup"
      [lazy]="true"
      [totalRecords]="1000"
      (onNodeExpand)="onNodeExpand($event)"
      [scrollable]="true"
    >
      <ng-template pTemplate="header" let-columns>
        <tr>
          <ng-container *ngFor="let col of columns; let i = index">
            <ng-container *ngIf="i === 0">
              <th class="Name">{{ col.header }}</th>
            </ng-container>

            <ng-container *ngIf="i > 0">
              <th class="icon {{ col.Key_Header }}">
                <i class="fas {{ col.icon }}"></i>
                <span class="Tool-Tip">{{ col.description }}</span>
              </th>
            </ng-container>
          </ng-container>
        </tr>
      </ng-template>
      <ng-template
        pTemplate="body"
        let-rowNode
        let-rowData="rowData"
        let-columns="columns"
      >
        <tr [ttRow]="rowNode">
          <ng-container *ngFor="let col of columns; let i = index">
            <ng-container *ngIf="i === 0">
              <td class="Name">
                <p-treeTableToggler
                  [rowNode]="rowNode"
                  *ngIf="i === 0"
                ></p-treeTableToggler>
                {{ rowData.Name }}
              </td>
            </ng-container>

            <ng-container *ngIf="i > 0">
              <td>
                <div class="Container-input Input-CheckBox">
                  <input
                    type="checkbox"
                    class="ui-checkbox"
                    (change)="changePermission(rowNode, rowData, col)"
                    [checked]="verify(rowData, col)"
                  />
                </div>
              </td>
            </ng-container>
          </ng-container>
        </tr>
      </ng-template>
    </p-treeTable>
  </div>
</div>

<!--~===================================== SECTION ALL MODALS =====================================~-->

<!---===================== MODAL FOR LOADER COMPONENT =====================--->
<div class="Container-Loader-Global" id="Loader">
  <div class="loader loader-1">
    <div class="loader-outter"></div>
    <div class="loader-inner"></div>
  </div>
</div>
